<script lang="ts">

    import { createEventDispatcher, onDestroy } from "svelte";

    const dispatch = createEventDispatcher();
    const slideHeight = 30;
    const controlHeight = 160;
    const maxY = controlHeight - slideHeight;

    let captureY: number;
    let y: number = 0;

    onDestroy(unregisterEventHandlers);

    function registerEventHandlers() {
        window.addEventListener('touchmove', onMove);
        window.addEventListener('mousemove', onMove);
        window.addEventListener('touchend', onRelease);
        window.addEventListener('mouseup', onRelease);
    }

    function unregisterEventHandlers() {
        window.removeEventListener('touchmove', onMove);
        window.removeEventListener('mousemove', onMove);
        window.removeEventListener('touchend', onRelease);
        window.removeEventListener('mouseup', onRelease);
    }

    function onCapture(event: MouseEvent | TouchEvent) {
        event.preventDefault();
        captureY = getClientY(event);
        registerEventHandlers();
    }

    function onMove(event: MouseEvent | TouchEvent) {
        const clientY = getClientY(event);
        const movement = clientY - captureY;
        const finalY = Math.max(0, Math.min(maxY, y + movement));
        
        if (finalY === y) {
            return;
        }

        captureY = clientY;
        y = finalY;
        dispatch('change', 1 - (y / maxY));
    }

    function onRelease() {
        unregisterEventHandlers();
    }

    function getClientY(event: MouseEvent | TouchEvent): number {
        if (isTouchEvent(event)) {
            return event.touches[0].clientY;
        }
        return event.clientY;
    }

    function isTouchEvent(event: MouseEvent | TouchEvent): event is TouchEvent {
        return 'touches' in event;
    }

</script>

<style lang="scss">

    .volume-ctrl {
        position: relative;
        width: 100%;
        background-color: #fff;

        &::before {
            $width: 5px;
            content: '';
            display: block;
            position: absolute;
            width: $width;
            border-radius: 500px;
            top: $width;
            left: calc(50% - #{$width * 0.5});
            height: calc(100% - #{$width * 2});
            background-color: var(--color-primary);
        }
    }

    .slide {
        position: absolute;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        &::before {
            $size: 20px;
            content: '';
            display: block;
            width: $size;
            height: $size;
            border-radius: 50%;
            background-color: var(--color-primary);
        }
    }

</style>

<div class="volume-ctrl" style="height: {controlHeight}px">
    <div
        class="slide"
        style="transform: translateY({y}px); height: {slideHeight}px"
        on:touchstart={onCapture}
        on:mousedown={onCapture}></div>
</div>
